<template><div /></template>

<script>
export default {
  name: 'Eula',
}
</script>

<style scoped></style>
